<template>
  <v-dialog v-model="dialogState" persistent max-width="600px">
    <v-card>
      <v-toolbar color="accent" fixed>
        <v-toolbar-title>
          <v-icon left class="mt-n1">mdi-delete</v-icon>
          {{ $vuetify.lang.t("$vuetify.manager.delete_gln") }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-3">
        <h3>{{ $vuetify.lang.t("$vuetify.action.delete_confirm") }}</h3>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closePopup">
          <v-icon class="mr-3">mdi-close</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.cancel") }}
        </v-btn>
        <v-btn :loading="isSubmitting" @click="removeGln">
          <v-icon class="mr-3">mdi-delete</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "@/services/api";

export default {
  props: ["removeGlnPopup", "dpdata"],
  data: function() {
    return {
      dialogState: false,
      isSubmitting: false,
    };
  },
  watch: {
    removeGlnPopup(newVal) {
      this.dialogState = newVal;
    },
  },
  methods: {
    closePopup() {
      this.dialogState = false;
      this.$emit("closeRemoveGlnPopup");
    },
    removeGln() {
      if (!this.dpdata || !this.dpdata.id) {
        return;
      }

      this.isSubmitting = true;
      Api.gln("delete", this.dpdata.id)
        .then((data) => {
          this.$toast.ok(this.$vuetify.lang.t("$vuetify.action.update_success"));
          this.$emit("closeRemoveGlnPopup");
          this.$emit("reload", data);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
